module.exports = __webpack_public_path__ + "img/home_footer_icon06.503ae9a3.png";